// extracted by mini-css-extract-plugin
export var dataCell = "_lh-2";
export var dataRow = "_lh-0";
export var headerRow = "_lh-1";